import { render } from "./DepositDocument.vue?vue&type=template&id=587e75fe"
import script from "./DepositDocument.vue?vue&type=script&lang=js"
export * from "./DepositDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__